// Force Latin digits (0-9) everywhere.
// Converts Arabic-Indic (٠١٢٣٤٥٦٧٨٩) and Extended-Arabic/Persian (۰۱۲۳۴۵۶۷۸۹) → Latin (0-9).
const ARABIC_INDIC = /[٠-٩]/g;
const PERSIAN = /[۰-۹]/g;

export function toEnglishDigits(input) {
  if (input === null || input === undefined) return "";
  let s = String(input);
  s = s.replace(ARABIC_INDIC, (d) => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)));
  s = s.replace(PERSIAN, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)));
  return s;
}

export function fmtNum(n) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return toEnglishDigits(n);
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(num);
}

export function fmtRiyal(n) {
  return `${fmtNum(n)} ر.س`;
}

export default toEnglishDigits;
